import Vue from "vue";
import VueMeta from "vue-meta";
import VueMq from "vue-mq"
import App from "../views/App.vue";
import router from "./router/router";
import store from "./store/store";
import Globals from "./plugins/Globals";
import VueQuill from "vue-quill"


// Fjern meta plugin..
Vue.use(VueMeta)
Vue.use(Globals);
Vue.use(VueMq, {
	breakpoints: {
		mobilesmall: 320,
		mobile: 375,
		tablet: 768,
		tablethori: 1024,
		desktop: Infinity,
	}
})
Vue.use(VueQuill)

Vue.config.productionTip = false;

new Vue(
	{
		router,
		store,
		mounted: function ()
		{
			// this.$store.dispatch(types.ACTION_INIT_NOTIFICATIONS)
		},
		render: h => h(App)
	}).$mount("#app");